export default __webpack_public_path__ + "static/media/03AW1-2JUL66.e0ef5284.jpg";